// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"5c911d24","291":"adc945b3","358":"3c2de589","440":"086e27a3","575":"54542743"}[chunkId] + ".chunk.js";
};